module.exports = __webpack_public_path__ + "img/SmartPitch.e17be9ea.svg";